var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCookie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.724 6.527a1 1 0 00-1.308-.46 3.491 3.491 0 01-4.526-1.616 1 1 0 00-.582-.5.989.989 0 00-.765.059A3.376 3.376 0 0114 4.38a3.5 3.5 0 01-3.5-3.5.762.762 0 00-.913-.745A12 12 0 1024 11.88a11.8 11.8 0 00-1.276-5.353zM3.917 14.713a1 1 0 111-1 1 1 0 01-1 1zm4.75-8.166a2 2 0 11-2 2 2 2 0 012-2zM9 18.88a2 2 0 112-2 2 2 0 01-2 2zm4.667-7.75a1 1 0 111 1 1 1 0 01-1-1zM15 19.88a1 1 0 111-1 1 1 0 01-1 1zm3.5-4a1.5 1.5 0 111.5-1.5 1.5 1.5 0 01-1.5 1.5z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookie);
export default __webpack_public_path__ + "static/media/cookie.e8ede3b5.svg";
export { ForwardRef as ReactComponent };